// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3TEBR","requiredAsterisk":"Info_requiredAsterisk__27JSn"};